// extracted by mini-css-extract-plugin
module.exports = {"root":"DlpBreadcrumbs_root__14La5","breadcrumbItem":"DlpBreadcrumbs_breadcrumbItem__zXQcR","iconSeparator":"DlpBreadcrumbs_iconSeparator__I24KB"};